module.exports = __webpack_public_path__ + "img/point2_bgcircle01.faf94ea8.png";